import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { merge, Observable, of, tap } from 'rxjs';
import { checkLogin } from '../shared/auth.helper';

/**
 * Startup component for not authenticated users.
 */
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent {
  /**
   * Specifies if user is already logged in.
   */
  public loggedIn$: Observable<boolean> = merge(
    of(true),
    checkLogin(this.msalService, this.msalBroadcastService).pipe(
      tap(result => {
        if (result)
          this.router.navigate(['/home']);
      })
    )
  );

  /**
   * Creates an instance of component.
   * 
   * @param msalService MSAL service.
   * @param msalBroadcastService MSAL event broker service.
   * @param router Application router.
   */
  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router) { }

  /**
   * Initiates user login.
   */
  login() {
    this.msalService.loginRedirect();
  }
}
